module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-tr-TR.f4cde47d.jpg";